// extracted by mini-css-extract-plugin
export default {"modal":"Idletimer_modal__cvhNO"};